import 'angular:locale/data:za';
import 'angular:locale/data:vn';
import 'angular:locale/data:us';
import 'angular:locale/data:uk';
import 'angular:locale/data:tr';
import 'angular:locale/data:th';
import 'angular:locale/data:si';
import 'angular:locale/data:se';
import 'angular:locale/data:sa';
import 'angular:locale/data:ro';
import 'angular:locale/data:pt';
import 'angular:locale/data:pl';
import 'angular:locale/data:ph';
import 'angular:locale/data:nz';
import 'angular:locale/data:nl';
import 'angular:locale/data:ng';
import 'angular:locale/data:my';
import 'angular:locale/data:mx';
import 'angular:locale/data:ma';
import 'angular:locale/data:kr';
import 'angular:locale/data:ke';
import 'angular:locale/data:jp';
import 'angular:locale/data:jm';
import 'angular:locale/data:it';
import 'angular:locale/data:in';
import 'angular:locale/data:ie';
import 'angular:locale/data:id';
import 'angular:locale/data:hu';
import 'angular:locale/data:hr';
import 'angular:locale/data:gr';
import 'angular:locale/data:fr';
import 'angular:locale/data:es';
import 'angular:locale/data:eg';
import 'angular:locale/data:de';
import 'angular:locale/data:cz';
import 'angular:locale/data:co';
import 'angular:locale/data:cl';
import 'angular:locale/data:ch';
import 'angular:locale/data:ca-en';
import 'angular:locale/data:ca-fr';
import 'angular:locale/data:br';
import 'angular:locale/data:be';
import 'angular:locale/data:aus';
import 'angular:locale/data:at';
import 'angular:locale/data:ar';
import 'angular:locale/data:ae';
import 'angular:locale/data:en';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
